var styleDataHash = "35eaa4ff";
const injectCss = () => {
  var css = `._4TJq-{--wds-side-panel-footer-padding-horizontal:18px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var new_color_picker_default = {
  "pickerHeader": "_4TJq-"
};
export {
  new_color_picker_default as default,
  injectCss
};
//# sourceMappingURL=new-color-picker-scss.js.map
